import React from "react";

const MembershipHistoryModal = ({ data = [], user, onClose }) => {
  return (
    <div className="history-overlay">
      <div className="history-modal">

        {/* HEADER */}
        <div className="header">
          <div>
            <h3>{user?.name}</h3>
            <p className="sub">Subscription History</p>
          </div>
          <span onClick={onClose} className="close-btn">✕</span>
        </div>

        {/* SCROLL AREA */}
        <div className="timeline-scroll">

          <div className="timeline">

            {data.map((item, i) => (
              <div key={i} className="timeline-item">

                {/* LEFT DOT + LINE */}
                <div className="timeline-left">
                  <div className="dot"></div>
                  {i !== data.length - 1 && <div className="line"></div>}
                </div>

                {/* CONTENT */}
                <div className="content">
                  <div className="title">
                    {item.planId?.title}
                    <span className={`badge ${item.planId?.type?.toLowerCase()}`}>
                      {item.planId?.type}
                    </span>
                  </div>

                  <div className="date">
                    {new Date(item.purchaseDate).toLocaleDateString()} → {
                      item.expiryDate
                        ? new Date(item.expiryDate).toLocaleDateString()
                        : "Now"
                    }
                  </div>

                  <div className={`status ${item.status.toLowerCase()}`}>
                    {item.status === "ACTIVE" ? "Active" : "Expired"}
                  </div>
                </div>

              </div>
            ))}

          </div>

        </div>

      </div>

      {/* STYLES */}
      <style>{`

        .history-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.75);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .history-modal {
          background: linear-gradient(145deg, #1e1e1e, #262626);
          border-radius: 16px;
          width: 420px;
          max-height: 80vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0,0,0,0.6);
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          position: sticky;
          top: 0;
          background: #1e1e1e;
          z-index: 2;
        }

        .header h3 {
          color: #fff;
          margin: 0;
        }

        .sub {
          font-size: 12px;
          color: #aaa;
        }

        .close-btn {
          cursor: pointer;
          font-size: 18px;
          color: #aaa;
        }

        .timeline-scroll {
          overflow-y: auto;
          max-height: 60vh;
          padding: 16px;
        }

        .timeline-item {
          display: flex;
          gap: 12px;
          position: relative;
        }

        .timeline-left {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #3b82f6;
          border-radius: 50%;
        }

        .line {
          width: 2px;
          flex: 1;
          background: rgba(255,255,255,0.1);
          margin-top: 4px;
        }

        .content {
          padding-bottom: 20px;
        }

        .title {
          color: #fff;
          font-weight: 600;
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .badge {
          font-size: 10px;
          padding: 2px 8px;
          border-radius: 10px;
        }

        .badge.free {
          background: rgba(255,255,255,0.1);
          color: #ccc;
        }

        .badge.pro {
          background: rgba(59,130,246,0.2);
          color: #3b82f6;
        }

        .badge.ambassador {
          background: rgba(251,191,36,0.2);
          color: #facc15;
        }

        .date {
          font-size: 12px;
          color: #aaa;
          margin-top: 2px;
        }

        .status {
          font-size: 12px;
          margin-top: 4px;
          font-weight: 500;
        }

        .status.active {
          color: #22c55e;
        }

        .status.expired {
          color: #ef4444;
        }

        /* scrollbar */
        .timeline-scroll::-webkit-scrollbar {
          width: 5px;
        }

        .timeline-scroll::-webkit-scrollbar-thumb {
          background: rgba(255,255,255,0.2);
          border-radius: 10px;
        }

      `}</style>
    </div>
  );
};

export default MembershipHistoryModal;